import { atom } from "recoil";

export const userRoleAtom = atom<string | null>({
  key: "userRoleAtom",
  default: null,
});
